export const checkApiFrame = async (masterSheet, frame, isMultiValidable) => {
  console.log("checkApiFrame :>> start");

  // this.frameに未使用フレームが指定されているか、空なのかをチェックする必要がある
  // TheMenuにも同じ記述あり
  let apiFrame = "normal";

  // サブスク型(is_fixed_frame==false)で、空なら未使用フレームを新たに生成
  const isSubscriptionAndEmpty =
    frame && !frame.id && !masterSheet.is_fixed_frame;

  console.log("isMultiValidable :>> ", isMultiValidable);
  if (isSubscriptionAndEmpty) {
    apiFrame = "SubscriptionAndEmpty";
  } else if (isMultiValidable) {
    apiFrame = "isMultiValidable";
  }

  console.log("checkApiFrame :>> end", apiFrame);
  return apiFrame;
};
